import { render, staticRenderFns } from "./Revision.vue?vue&type=template&id=71baa684&scoped=true&"
import script from "./Revision.vue?vue&type=script&lang=js&"
export * from "./Revision.vue?vue&type=script&lang=js&"
import style0 from "./Revision.vue?vue&type=style&index=0&id=71baa684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71baa684",
  null
  
)

export default component.exports